import { Link, useParams } from 'react-router';
import { api } from '../../shared/api/client';
import { ErrorState, Loading, Logo } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { formatWhen } from './shared';
import { CalendarShareButtons } from './AddToCalendar';

type PublicMeeting = {
  topic: string;
  ministries: string[];
  speaker: string | null;
  startsAt: string;
  endsAt: string;
  placeName: string | null;
  address: string | null;
  mapsUrl: string | null;
  churchName: string;
};

/** Reunión pública: cualquiera la ve sin cuenta (sin comida ni peticiones, que son de quienes participan). */
export function PublicMeetingPage() {
  const { token = '' } = useParams();
  const data = useAsync((signal) => api.get<PublicMeeting>(`/organization/public/meetings/${encodeURIComponent(token)}`, signal), [token]);
  return (
    <div className="landing">
      <header className="landing__bar">
        <Link to="/" aria-label="KEORA">
          <Logo />
        </Link>
      </header>
      <main className="public public-event">
        {data.status === 'loading' ? <Loading /> : null}
        {data.status === 'error' ? <ErrorState error={data.error} /> : null}
        {data.status === 'ready' ? (
          <>
            <p className="eyebrow">
              {data.data.churchName} te invita{data.data.ministries.length ? ` · ${data.data.ministries.join(' + ')}` : ''}
            </p>
            <h1>{data.data.topic}</h1>
            <p className="public-event__when">{formatWhen(data.data.startsAt, data.data.endsAt)}</p>
            <CalendarShareButtons
              event={{
                uid: `r-${token}`,
                title: data.data.topic,
                startsAt: data.data.startsAt,
                endsAt: data.data.endsAt,
                location: [data.data.placeName, data.data.address].filter(Boolean).join(', ') || null,
              }}
            />
            {data.data.speaker ? <p>Comparte: {data.data.speaker}</p> : null}
            {data.data.placeName || data.data.address ? (
              <p>
                {data.data.placeName ? <strong>{data.data.placeName}</strong> : null}
                {data.data.address ? <span className="block muted">{data.data.address}</span> : null}
                {data.data.mapsUrl ? (
                  <a href={data.data.mapsUrl} target="_blank" rel="noopener noreferrer" className="block">
                    Cómo llegar
                  </a>
                ) : null}
              </p>
            ) : null}
          </>
        ) : null}
      </main>
    </div>
  );
}
